let initialState = null;

export function token(state = initialState, action) {
  switch (action.type) {
    case "GET_TOKEN":
      return state;
    case "SET_TOKEN":
      return action.token;
    case "DESTROY_TOKEN":
      return null;
    case "UNAUTHENTICATE_TOKEN":
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/token.js